var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading.lock",
            value: _vm.fullscreenLoading,
            expression: "fullscreenLoading",
            modifiers: { lock: true },
          },
        ],
        staticClass: "main-content fullCycle fullCss",
        style: _vm.mainContentViewHeight,
      },
      [
        _c("headerCom", {
          ref: "headerCom",
          staticClass: "header",
          attrs: {
            type: 5,
            pageTitle: "招标计划监管",
            datacount: _vm.navTotal,
          },
          on: {
            navchange: _vm.navClickHandle,
            showBox: _vm.showBoxHandle,
            searchclick: _vm.searchClickHandle,
          },
        }),
        _vm.showFlag
          ? _c("screenCom", {
              staticClass: "screen",
              attrs: {
                type: 5,
                projectTypeList: _vm.projectTypeList,
                projectReleaseStatusList: _vm.projectReleaseStatusList,
                regionTreeList: _vm.regionTreeList,
                navClick: _vm.systemType,
              },
              on: { projectemit: _vm.projectEmitHandle },
            })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "my_table" },
          [
            _vm.dataMsg.length == 0
              ? _c("div", { staticClass: "no_message" }, [
                  _c("p", [_vm._v("暂无数据")]),
                ])
              : _c(
                  "div",
                  { staticClass: "project_item" },
                  _vm._l(_vm.dataMsg, function (item, i) {
                    return _c("projectCom", {
                      key: i,
                      staticClass: "project_par",
                      attrs: {
                        type: 5,
                        data: item,
                        isShowTag: true,
                        projectReleaseStatusList: _vm.projectReleaseStatusList,
                        hasViewBtnPer: _vm.hasBtnPermission(
                          "supperviseion_biddingPlanWitnessHis_detail_btn"
                        ),
                        keyCopy: i,
                        systemType: _vm.systemType,
                      },
                    })
                  }),
                  1
                ),
            _c("paginationCom", {
              staticClass: "limit",
              attrs: { options: _vm.paginationOpt },
              on: {
                sizechange: _vm.sizeChangeHandle,
                pagechange: _vm.pageChangeHandle,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }